module.exports = "@media only screen and (min-width: 992px) {\n    ::ng-deep .mat-tab-label{\n            min-width: 400px !important;           \n    }\n    ::ng-deep .mat-tab-label-content{\n        font-weight: bolder !important;           \n    }\n    ::ng-deep .mat-ink-bar{\n        width: 400px;\n    }\n    \n}\n\n::ng-deep \n    mat-tab-header {\n        display: none !important;\n    } "


//////////////////
// WEBPACK FOOTER
// ./src/app/work-shops/work-shops.component.css
// module id = ./src/app/work-shops/work-shops.component.css
// module chunks = main